import { render } from "./PersonalSavingsPerform.vue?vue&type=template&id=7e842241"
import script from "./PersonalSavingsPerform.vue?vue&type=script&lang=js"
export * from "./PersonalSavingsPerform.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__